import { AxiosError } from 'axios';
import { DocFileSource } from '../types/documentCapture.types';

/** Version-history meta stamp: "Jul 27, 14:36". */
export function formatVersionStamp(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${date}, ${time}`;
}

/** Chip-sized date: "Jul 27". */
export function formatShortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** "1.8 MB" (one decimal), falling back to KB for small files. */
export function formatBytes(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

export function pluralPages(count: number): string {
  return `${count} ${count === 1 ? 'page' : 'pages'}`;
}

/** Display labels for the version-history source column. */
export const DOC_FILE_SOURCE_LABELS: Record<DocFileSource, string> = {
  [DocFileSource.Watcher]: 'Scan',
  [DocFileSource.Manual]: 'Uploaded',
  [DocFileSource.Backfill]: 'Backfill',
  [DocFileSource.ReviewAssigned]: 'Assigned in review',
  [DocFileSource.Restore]: 'Restored',
};

/** Status + plain-language message off an apiClient failure (the useReviewDecision idiom). */
export function apiErrorInfo(err: unknown): { status?: number; message?: string; timedOut?: boolean } {
  if (err instanceof AxiosError) {
    return {
      status: err.response?.status,
      message: (err.response?.data as { message?: string } | undefined)?.message,
      // No server response = a client timeout (ECONNABORTED) or transport drop — NOT a bad file
      // (86d3uf18j S10). The preflight decode can legitimately hit the 150s bound when the shared
      // decode pool is saturated; callers should say "busy, retry", not "damaged, re-export".
      timedOut: err.code === 'ECONNABORTED' || !err.response,
    };
  }
  return {};
}
